import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-date-time',
  templateUrl: './formly-date-time.component.html',
})
export class FormlyDateTimeComponent extends FieldType<FieldTypeConfig> {
  date: number = new Date().getTime();
}
